import React, { useState, useEffect } from 'react';
import * as styledComponents from './styles'
import { Container, Row, Col } from 'react-bootstrap';
import Modal from 'react-modal';
import { useHistory } from "react-router";
import 'video-react/dist/video-react.css';
import {
  Player,
  ControlBar,
  ReplayControl,
  ForwardControl,
  CurrentTimeDisplay,
  TimeDivider,
  PlaybackRateMenuButton,
  VolumeMenuButton
} from 'video-react';

const URL = 'https://script.google.com/macros/s/AKfycbyVGECAqpGrKySN6nx2J72JEL6fTgoScB3HXQhd2rjBmG3RY41K/exec';

const getModalTitle = (state) => {
  switch (state) {
    case 'sending':
      return 'SENDING';
    case 'success':
      return 'THANK YOU!';
    case 'failure':
    default:
      return 'WE ARE SORRY';
  }
};

const getModalDescription = (state) => {
  switch (state) {
    case 'sending':
      return 'We are sending the request. It may take some seconds...';
    case 'success':
      return 'Here you have your Excel Template, remember that you can make a free 30 min consultation to define how your product should look like.';
    case 'failure':
    default:
      return 'There is an issue in our system. Please try again later.';
  }
}

const modalStyle = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.70)',
    zIndex: '100',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '600px',
    maxWidth: '95%',
    padding: '80px 20px',
    zIndex: '101',
    background: 'linear-gradient(169.29deg, #262B2F -0.68%, #16191D 74.03%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    border: 'none',
  },
};

const downloadPDF = () => {
  fetch('/guide/template_request.xlsx')
    .then(resp => resp.blob())
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = 'ProjectScoping.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    })
}

const Benefits = React.forwardRef((props, ref) => {

  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalState, setModalState] = useState('sending');
  const history = useHistory();

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
  }
  const handleChangeName = (e) => {
    setName(e.target.value);
  }
  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen);
  }

  const sendRequest = (e) => {
    e.preventDefault();
    toggleModal();
    setModalState('sending');
    var formData = new FormData();
    formData.append('email', email);
    formData.append('name', name);
    fetch(URL, { method: 'POST', body: formData })
      .then((response) => {
        if (response.ok) {
          downloadPDF();
          setModalState('success');
          setEmail('');
          setName('');
          setTimeout(() => {
            setModalIsOpen(false);
          }, 15000);
        } else {
          setModalState('failure');
          setTimeout(() => {
            setModalIsOpen(false);
          }, 5000);
        }
      });
  }

  useEffect(() => {
    Modal.setAppElement('#root');
  }, [])

  return (
    <styledComponents.PortfolioContainer ref={ref}>
      <Modal
        style={modalStyle}
        isOpen={modalIsOpen}
        onRequestClose={toggleModal}
      >
        <styledComponents.ModalTitle>{getModalTitle(modalState)}</styledComponents.ModalTitle>
        <styledComponents.ModalContent>{getModalDescription(modalState)}</styledComponents.ModalContent>
        {modalState === 'success' && <styledComponents.CallToAction onClick={() => { window.open("https://calendly.com/luisenriquecgongora") }}>FREE CONSULTATION</styledComponents.CallToAction>}
      </Modal>
      <Container>
        <Row>
          <Col md>
            <styledComponents.ContainerListDesktop>
              <Player>
                <source src="/guide/project_scoping.mp4" />
                <ControlBar>
                  <ReplayControl seconds={10} order={1.1} />
                  <ForwardControl seconds={30} order={1.2} />
                  <CurrentTimeDisplay order={4.1} />
                  <TimeDivider order={4.2} />
                  <PlaybackRateMenuButton rates={[5, 2, 1, 0.5, 0.1]} order={7.1} />
                  <VolumeMenuButton disabled />
                </ControlBar>
              </Player>
            </styledComponents.ContainerListDesktop>
          </Col>
          <Col md>
            <styledComponents.Title>
              FINALLY YOUR PROJECT MAKES SENSE IN YOUR HEAD AND YOU WANT TO EXECUTE IT. BUT HOW TO DEFINE ALL OF YOUR NEEDS SO A DEVELOPER OR AN OUTSOURCING COMPANY CAN CREATE IT PROPERLY?
            </styledComponents.Title>
            <styledComponents.ContainerListPhone>
              <Player>
                <source src="/guide/project_scoping.mp4" />
                <ControlBar>
                  <ReplayControl seconds={10} order={1.1} />
                  <ForwardControl seconds={30} order={1.2} />
                  <CurrentTimeDisplay order={4.1} />
                  <TimeDivider order={4.2} />
                  <PlaybackRateMenuButton rates={[5, 2, 1, 0.5, 0.1]} order={7.1} />
                  <VolumeMenuButton disabled />
                </ControlBar>
              </Player>
            </styledComponents.ContainerListPhone>
            <styledComponents.Description>
              The truth about starting to develop your own project is that most of people just get stuck into the idea. After that, if you do not have the technical
              skills to develop the project you would need to hire a developer or an outsourcing company to create the desired product. <br /><br />
              In most of the cases you will receive a buggy or incomplete product. The following excel template allows you to define all of your requirements so you receive a fully functional product.
                   </styledComponents.Description>
            <styledComponents.InputsContainer onSubmit={sendRequest}>
              <styledComponents.Input placeholder={'Full Name* (or Company Name)'} onChange={handleChangeName} value={name} required />
              <styledComponents.Input placeholder={'Email Address*'} onChange={handleChangeEmail} value={email} required type="email" />
              <styledComponents.CallToAction type="submit">GET EXCEL TEMPLATE</styledComponents.CallToAction>
            </styledComponents.InputsContainer>
          </Col>
        </Row>
      </Container>
    </styledComponents.PortfolioContainer>
  );
});

export default Benefits;
